import { Component, Injector, OnInit } from '@angular/core';
import { GeozoneViewModel } from "../Model/GeozoneViewModel";
import { ZoneService } from "../../../../services/zones.service";
import { DialogBaseComponent } from "../../base-admin-panel/dialog-base/dialog-base.component";
import { IManagableObject } from '../../IManagableObject';
import { ContainersService } from 'app/services/containers.service';
import { ContainerViewModel } from '../../ContainerViewModel';

@Component({
  selector: 'app-create-geozone-dialog',
  templateUrl: './create-geozone-dialog.component.html',
  styleUrls: ['./create-geozone-dialog.component.css'],
  standalone: false
})
export class CreateGeozoneDialogComponent extends DialogBaseComponent<GeozoneViewModel> implements OnInit {

  private zonesService: ZoneService;
  private containersService: ContainersService;

  public groups: IManagableObject[] = [];
  public containers: ContainerViewModel[] = [];
  constructor(protected injector: Injector) {
    super(injector);
    this.zonesService = injector.get(ZoneService);
    this.containersService = injector.get(ContainersService);
  }

  ngOnInit(): void {

    this.zonesService.GetGroups()
      .subscribe(groups => {
        this.groups = groups;
      });

    this.loadContainers();
  }

  submit() {
    if (!this.model.ContainerId) {
      this.toastr.error(this.translate.instant("Container is required"));
      return;
    }

    this.zonesService.CreateZone(this.model)
      .subscribe((res) => {
        this.syncService.NotifyEntityChanged("Geozone", this.model.Id);
        super.submit();
      });
  }

  private loadContainers() {
    const companyId = this.usersService.getCurrentUser()?.CompanyId ?? 0;
    if (!companyId) {
      this.containers = [];
      this.model.ContainerId = undefined;
      return;
    }

    this.containersService.GetContainers().subscribe(containers => {
      this.containers = containers ?? [];
      if (!this.model.ContainerId || !this.containers.some(x => x.Id === this.model.ContainerId))
        this.model.ContainerId = this.containers[0]?.Id;
    });
  }
}
